import React, { useContext, useEffect, useRef, useState } from 'react';
import { dispatchSkyfireMethods } from '../../utils';
import { useDispatch } from 'react-redux';
import { DESCRIPTIVE_LISTING } from '../../types/templates/widgets/ISkyfireDescriptiveListing';
import { DESCRIPTIVE_SHOVELER } from '../../types/templates/widgets/ISkyfireDescriptiveShoveler';
import { DESCRIPTIVE_SHOWCASE } from '../../types/templates/widgets/ISkyfireDescriptiveShowcase';
import { DESCRIPTIVE_TABLE_WIDGET } from '../../types/templates/widgets/ISkyfireDescriptiveTableWidget';
import { FEATURED_BANNER } from '../../types/templates/widgets/ISkyfireFeaturedBanner';
import { FEATURED_SHOVELER } from '../../types/templates/widgets/ISkyfireFeaturedShoveler';
import { LINK_NAVIGATOR_WIDGET } from '../../types/templates/widgets/ISkyfireLinkNavigatorWidget';
import { MESSAGE_WIDGET } from '../../types/templates/widgets/ISkyfireMessageWidget';
import { PILL_NAVIGATOR_WIDGET } from '../../types/templates/widgets/ISkyfirePillNavigatorWidget';
import { THUMBNAIL_NAVIGATOR_WIDGET } from '../../types/templates/widgets/ISkyfireThumbnailNavigatorWidget';
import { VISUAL_LISTING } from '../../types/templates/widgets/ISkyfireVisualListing';
import { VISUAL_SHOVELER, } from '../../types/templates/widgets/ISkyfireVisualShoveler';
import { VISUAL_SHOWCASE } from '../../types/templates/widgets/ISkyfireVisualShowcase';
import { VISUAL_TABLE_WIDGET } from '../../types/templates/widgets/ISkyfireVisualTableWidget';
import DescriptiveListing from './DescriptiveListing';
import DescriptiveShoveler from './DescriptiveShoveler';
import DescriptiveShowcase from './DescriptiveShowcase';
import DescriptiveTableWidget from './DescriptiveTableWidget';
import FeaturedBanner from './FeaturedBanner';
import FeaturedShoveler from './FeaturedShoveler';
import LinkNavigatorWidget from './LinkNavigatorWidget';
import MessageWidget from './MessageWidget';
import PillNavigatorWidget from './PillNavigatorWidget';
import ThumbnailNavigatorWidget from './ThumbnailNavigatorWidget';
import VisualListing from './VisualListing';
import VisualShoveler from './VisualShoveler';
import VisualTableWidget from './VisualTableWidget';
import Template from '../../Contexts/Template';
export default function Widget(props) {
    var _a, _b;
    const dispatch = useDispatch();
    const currTemplate = useContext(Template);
    const widgets = (_b = (_a = currTemplate) === null || _a === void 0 ? void 0 : _a.innerTemplate) === null || _b === void 0 ? void 0 : _b.widgets;
    const topWidget = widgets && widgets.length > 0 ? widgets[0] : undefined;
    const [topWidgetItemCount, setTopWidgetItemCount] = useState(topWidget && 'items' in topWidget && topWidget.items instanceof Array
        ? topWidget.items.length
        : 0);
    const isInitialRender = useRef(true);
    useEffect(() => {
        var _a, _b, _c;
        if (isInitialRender.current) {
            onViewed();
            isInitialRender.current = false;
            return;
        }
        const newTopWidget = ((_b = (_a = currTemplate) === null || _a === void 0 ? void 0 : _a.innerTemplate) === null || _b === void 0 ? void 0 : _b.widgets) && currTemplate.innerTemplate.widgets.length > 0
            ? currTemplate.innerTemplate.widgets[0]
            : undefined;
        // Dispatch onViewed methods when top widget is updated with new items,
        // to support pagination view metrics
        if (((_c = newTopWidget) === null || _c === void 0 ? void 0 : _c.items) && newTopWidget.items.length > topWidgetItemCount) {
            onViewed();
            setTopWidgetItemCount(newTopWidget.items.length);
        }
    }, [widgets]);
    const getWidget = () => {
        switch (props.data.interface) {
            case VISUAL_SHOVELER:
            case VISUAL_SHOWCASE:
                return (React.createElement(VisualShoveler, { data: props.data, handleSelected: props.handleSelected, key: props.data.header }));
            case DESCRIPTIVE_SHOVELER:
                return (React.createElement(DescriptiveShoveler, { data: props.data, handleSelected: props.handleSelected, key: props.data.header }));
            case FEATURED_SHOVELER:
                return (React.createElement(FeaturedShoveler, { data: props.data, handleSelected: props.handleSelected, key: props.data.header }));
            case DESCRIPTIVE_TABLE_WIDGET:
                return (React.createElement(DescriptiveTableWidget, { data: props.data, handleSelected: props.handleSelected }));
            case VISUAL_TABLE_WIDGET:
                return (React.createElement(VisualTableWidget, { data: props.data, handleSelected: props.handleSelected }));
            case LINK_NAVIGATOR_WIDGET:
                return (React.createElement(LinkNavigatorWidget, { items: props.data.items, header: props.data.header, handleSelected: props.handleSelected }));
            case THUMBNAIL_NAVIGATOR_WIDGET:
                return (React.createElement(ThumbnailNavigatorWidget, { header: props.data.header, items: props.data.items, handleSelected: props.handleSelected }));
            case VISUAL_LISTING:
                return (React.createElement(VisualListing, { data: props.data, handleSelected: props.handleSelected, key: props.data.header, isEnumerated: props.isEnumerated }));
            case DESCRIPTIVE_SHOWCASE:
                return (React.createElement(DescriptiveShowcase, { data: props.data, handleSelected: props.handleSelected, key: props.data.header }));
            case DESCRIPTIVE_LISTING:
                return (React.createElement(DescriptiveListing, { data: props.data, handleSelected: props.handleSelected, key: props.data.header, isEnumerated: props.isEnumerated }));
            case MESSAGE_WIDGET:
                return (React.createElement(MessageWidget, { data: props.data, handleSelected: props.handleSelected, key: props.data.message }));
            case FEATURED_BANNER:
                return React.createElement(FeaturedBanner, { data: props.data, key: props.data.imageAltText });
            case PILL_NAVIGATOR_WIDGET:
                return (React.createElement(PillNavigatorWidget, { data: props.data, handleSelected: props.handleSelected }));
            default:
                // @ts-ignore
                return React.createElement("p", null,
                    "Attempted to render unknown widget: ",
                    props.data.interface);
        }
    };
    const onViewed = () => {
        var _a;
        const onViewedMethods = props.data.onViewed;
        if (currTemplate && ((_a = onViewedMethods) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            dispatchSkyfireMethods(dispatch, currTemplate, onViewedMethods);
        }
    };
    const onrendered = () => {
        if (props.rendered) {
            props.rendered();
        }
    };
    return React.createElement("music-container", { onrendered: onrendered }, getWidget());
}
